import { React, Button, useState, useEffect } from "../utils/thirdpartyComponents"
import { splitTotal , showTrailText, formatMoney, getCurrencySymbol} from "../utils/helper";


const WashSelection = ({ SubscriptionID, WashName, SubscriptionDetails, Price, NumberOfWashes, dailyWashLimit, show_single_wash, buyType, hasActiveSubscription, setShowUpdateConfirmation, onBuynowClick, subscription, cancelConfirmation, subscriptionType , TrialSubscriptionAvailable , scanAction , bayselectAction, insidelocationcheck, activesinglewashid , coords, isGeolocationAvailable, isGeolocationEnabled,activeUserSubscriptionID,HasVacuumWash,NumberOfVacuumWashes,MaxVacuumTime,IsUnlimitedWash,FamilyDiscount,ActiveBulkWash,HasFreeSelfServe,NumberOfFreeSelfWashes,MaxSelfServiceTime}: any) => {

    // State to manage more and less button
    const [showAll, setShowAll] = useState(false);
    const type = subscriptionType==3 ? "bulk" : ""
    // Determine which items to display based on showAll state
    const visibleDescription = showAll ? SubscriptionDetails : SubscriptionDetails ? (SubscriptionDetails.length > 150 ? `${SubscriptionDetails.substring(0, 150)}...` : SubscriptionDetails) : '';

    const toggleShowAll = () => {
        setShowAll(!showAll);
    };
    const { dollars, cents } = Price ? splitTotal(Price) : { dollars: "", cents: "" }
    const centswith2Digit = (cents && cents.length < 2) ? cents + '0' : cents;
    let btnLabel = 'Buy';
    if (subscriptionType == 2 && subscription.isTrial && TrialSubscriptionAvailable === true) {
        btnLabel = 'Start Trial';
    }



    const activewashCheck = () => {
        if(subscriptionType == 1)
        {
            if (  insidelocationcheck === true && activesinglewashid == 0 && 
                  (isGeolocationAvailable && isGeolocationEnabled && coords !== undefined && coords?.latitude && coords?.longitude))
                  {
                    return true
                  }
                  else{
                     return false
                  }
           

        }
        else  if(subscriptionType == 3){
            if (  insidelocationcheck === true && ActiveBulkWash == false && 
                  (isGeolocationAvailable && isGeolocationEnabled && coords !== undefined && coords?.latitude && coords?.longitude))
                  {
                    return true
                  }
                  else{
                     return false
                  }

        }
      
        else{
           return false 
        }

        
        

    }

    return (
        <div className="cw-card">
            <div className="cw-card-content">
                <div className="cw-card-leftcontent">
                    <h6>{WashName}</h6>
                    <div
                    className="cw-card-leftcontent "
                    dangerouslySetInnerHTML={{ __html: visibleDescription }}
                    ></div>
                    {/* {visibleDescription} */}

                    <div>
                        {SubscriptionDetails ? (SubscriptionDetails.length > 150 && (

                            <a onClick={toggleShowAll} className="more-less-btn">
                                {showAll ? <>
                                    <span className="align-text-top">Less</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="8.148" height="10.365" viewBox="0 0 8.148 10.365"><g transform="translate(1.061 9.615) rotate(-90)"><g transform="translate(-7.003 -9.256)"><line x2="8.199" transform="translate(7.003 12.269)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /><path d="M13,8l3.014,3.014L13,14.027" transform="translate(-0.146 1.256)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /></g></g></svg>
                                </> : <><span className="align-text-top">More</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="8.148" height="10.365" viewBox="0 0 8.148 10.365"><g transform="translate(7.088 0.75) rotate(90)"><g transform="translate(-7.003 -9.256)"><line x2="8.199" transform="translate(7.003 12.269)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /><path d="M13,8l3.014,3.014L13,14.027" transform="translate(-0.146 1.256)" fill="none" stroke="#0182f0" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" /></g></g></svg>
                                </>} </a>

                        )) : ''}
                    </div>
                </div>
                <div className="cw-card-rightcontent">
                    <div className="cw-card-value">{getCurrencySymbol()}{dollars || 0} 
                        <span className="decimal-sec">.{cents ? centswith2Digit : "00"}</span>
                    </div>
                    {subscriptionType == 2 ? <div className="cw-card-smalltext">Per Month</div> : null}

                </div>
            </div>
            {subscriptionType == 2 ? <div className="wash-number mt-2">Washes per day  <span className="ms-1">{dailyWashLimit}</span></div> : null}
                   {HasVacuumWash == 1 ?       <div className="wash-number mt-3"> <span >{NumberOfVacuumWashes} </span> Free Vacuum {NumberOfVacuumWashes === 1 ? "session" : "sessions"} available for <span >{MaxVacuumTime}</span> min per use</div>  :""}
                    {HasFreeSelfServe == 1 ?       <div className="wash-number mt-3"> <span >{NumberOfFreeSelfWashes} </span> Free SelfServe {NumberOfFreeSelfWashes === 1 ? "session" : "sessions"} available for <span >{MaxSelfServiceTime}</span> min per use</div>  :""}

            
            {(subscriptionType == 1 && SubscriptionID === activesinglewashid)? <div className="active-plan d-flex align-items-center fw-semibold"><span className="active-bubble"></span>Active</div> : ''}
            {(isGeolocationAvailable && isGeolocationEnabled && coords !== undefined && coords?.latitude && coords?.longitude )? '' : subscriptionType == 2 || scanAction === true || bayselectAction === true || localStorage.getItem('locationPermissionGranted') === 'true'  ? '' : <div className="warn-plan d-flex align-items-center fw-semibold">Please allow Location permission for this app to check your proximity to the car wash location.</div>}
            {(isGeolocationAvailable && isGeolocationEnabled && coords !== undefined && coords?.latitude && coords?.longitude &&  insidelocationcheck === false)? (subscriptionType == 2 || scanAction === true || bayselectAction === true  ? '' : <div className="warn-plan d-flex align-items-center fw-semibold">Purchase this wash at the car wash.</div> ) : ''}
            <div className="cw-card-btnwrap grid-btn-wrap">
                {hasActiveSubscription != SubscriptionID ? 
                <Button variant="primary" className="primary-btn" 
                onClick={() => onBuynowClick(subscription, buyType === 2 ? "subscriptions" : "singlewash")} 
                // disabled={
                //   subscriptionType == 2 ||
                //   scanAction === true || 
                //   bayselectAction === true || 
                //   (insidelocationcheck === true && activesinglewashid == 0 && 
                //   (isGeolocationAvailable && isGeolocationEnabled && coords !== undefined && coords?.latitude && coords?.longitude))
                //     ? false 
                //     : true
                // }
                disabled={
                  subscriptionType == 2 ||
                   scanAction === true || 
                    // bayselectAction === true ||
                     activewashCheck() == true

                
                    ? false 
                    : true
                }
                >{btnLabel}</Button> 
                : 
                <Button variant="primary" className="primary-btn" onClick={() =>{cancelConfirmation(activeUserSubscriptionID)} }>Cancel</Button>}
                
                
                
                {/* {type == "bulk" ?<div className="washes-wrap">
                    <span className="washes-text">Washes</span>
                    <div className="washes-count">{ NumberOfWashes}</div>
                </div> :""
                } */}
                {IsUnlimitedWash ? <div className="washes-wrap">
                    <span className="washes-text">Washes</span>
                    <div className="washes-count unlimited">Unlimited</div>
                </div> : <div className="washes-wrap">
                    <span className="washes-text">Washes</span>
                    <div className="washes-count">{ NumberOfWashes || 1}</div>
                </div> }


            </div>
            {(subscriptionType == 2 && subscription?.isTrial && TrialSubscriptionAvailable === true)? <div className="trial-strip"><p dangerouslySetInnerHTML={{__html: showTrailText(subscription?.trialAmount, subscription?.trialPeriod, true)}} ></p></div> : ''}
            {(subscriptionType == 2 &&  FamilyDiscount && FamilyDiscount>0)? <div className="trial-strip"><p >Family Plan Amount {formatMoney(FamilyDiscount)} Per Month</p></div> : ''}

        </div>

    )
}
export default WashSelection